<template>
    <div class="apprentice-simple-card current-assignment">
        <div class="header">
            <h5 class="title">{{ $t('learning_path.exercises') }}</h5>
            <b-button
                class="btn-add btn-add-lp-assignment"
                variant="primary-icon-only"
                @click="showLearningPath">
            </b-button>
        </div>
        <div
            class="body"
            v-if="lpAssignmentsIn.length > 0">
            <ul class="list-unstyled lp-assignments">
                <design-2021-learning-path-current-assignment-component
                    v-for="lpAssignment of lpAssignmentsIn"
                    :lp-assignment-in="lpAssignment"
                    :key="lpAssignment.id">
                </design-2021-learning-path-current-assignment-component>
            </ul>
        </div>

        <div
            class="not-found with-header empty-assignments-list"
            v-else>
            <div
                class="btn-add-circle icon"
                :title="$t('learning_path.no_exercises_found')"
                @click="showLearningPath"></div>
            <div class="alert-notice">{{ $t('learning_path.no_exercises_found') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-learning-path-current-assignments-component',
    props: {
        lpAssignmentsIn: {
            type: Array,
            required: true,
        },
    },
    methods: {
        showLearningPath() {
            window.location.href = this.routes.learningPath();
        },
    },
};
</script>

<style scoped lang="scss">
.header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 map-get($grid-gutter-spacing, 'twenty-one') map-get($grid-gutter-spacing, 'fifteen')
        map-get($grid-gutter-spacing, 'twenty-one');
    margin: 0 -#{map-get($grid-gutter-spacing, 'twenty-one')} map-get($grid-gutter-spacing, 'fifteen') -#{map-get(
            $grid-gutter-spacing,
            'twenty-one'
        )};
    border-bottom: 1px solid $border-color;

    .title {
        margin-bottom: 0;
        font-weight: $font-weight-bold;
    }

    .btn-add-lp-assignment {
        &:before {
            margin-right: 0;
        }
    }
}

.lp-assignments {
    margin-bottom: 0;
}

.not-found {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
}
</style>
